import hourglass from '../elements/hourglass.js';
hourglass.register();
